<template>
  <v-app id="app">

    <HeaderComponent></HeaderComponent>

    <router-view></router-view>

    <FooterComponent></FooterComponent>

  </v-app>
</template>

<script>
// @ is an alias to /src
import HeaderComponent from '@/components/HeaderComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'

export default {
  name: 'app',
  components: {
    HeaderComponent,
    FooterComponent
  },
  metaInfo: {
    title: 'TOJO Technology Company Limited',
    meta: [{
      vmid: 'description',
      name: 'description',
      content: 'IT Service Provider'
    }, {
      vmid: 'og:title',
      property: 'og:title',
      content: 'TOJO Technology Company Limited'
    }, {
      vmid: 'og:url',
      property: 'og:url',
      content: 'http://www.tojotech.com/'
    }, {
      vmid: 'og:description',
      property: 'og:description',
      content: 'IT Service Provider'
    }, {
      vmid: 'og:image',
      property: 'og:image',
      content: require('@/assets/logo-meta-head.png')
    }, {
      vmid: 'og:type',
      property: 'og:type',
      content: 'article'
    }, {
      vmid: 'og:locale',
      property: 'og:locale',
      content: 'en'
    }, {
      vmid: 'og:locale:alternate',
      property: 'og:locale:alternate',
      content: 'zh_HK'
    }, {
      vmid: 'og:locale:alternate',
      property: 'og:locale:alternate',
      content: 'zh_CN'
    }],
    link: [{
      rel: 'icon',
      href: '/favicon.ico'
    }]
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

</style>
